"use strict";

exports.__esModule = true;
exports.StyledText = void 0;

var _stitches = require("../theme/stitches.config");

const StyledText = (0, _stitches.styled)('p', {
  variants: {
    weight: {
      hairline: {
        fontWeight: '$hairline'
      },
      thin: {
        fontWeight: '$thin'
      },
      light: {
        fontWeight: '$light'
      },
      normal: {
        fontWeight: '$normal'
      },
      medium: {
        fontWeight: '$medium'
      },
      semibold: {
        fontWeight: '$semibold'
      },
      bold: {
        fontWeight: '$bold'
      },
      extrabold: {
        fontWeight: '$extrabold'
      },
      black: {
        fontWeight: '$black'
      }
    }
  }
});
exports.StyledText = StyledText;